import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField,
    ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Meta_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_META_ID:     {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Meta WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    META_ID:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Meta Id', columnResourceName: 'colMetaId', alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    META_NAME:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    META_SORT_ID:   {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Meta Sort ID', columnResourceName: 'colMetaSortID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    SOURCE_ID:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source ID', columnResourceName: 'colSourceID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    META_TYPE_ID:   {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Meta Type ID', columnResourceName: 'colMetaTypeID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const MetaSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_META_ID',
        id_ui: 'META_ID',
        name:  'META_NAME'},

    searchProviderFields: vUI_Meta_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Meta_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


const MetaSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "MetaSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'META_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'META_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'META_ID','META_NAME','META_SORT_ID',,'SOURCE_ID','META_TYPE_ID', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: MetaSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const MetaSearchProfileBySource: ISearchProfile = {
    profileId: "MetaType",
    profileName: "Search by MetaType",
    renderOptions: { ui5ResourceId: "MetaSearchProfileByMetaType" },

    profileFilter: [
        {profileFilterName: 'MetaTypeID',     searchProviderFieldId: 'META_TYPE_ID', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'META_ID','META_NAME','META_SORT_ID','SOURCE_ID','META_TYPE_ID', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: MetaSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const MetaSearch: ISearch = {
    searchName: "Find Meta",
    renderOptions: { ui5ResourceId: "MetaSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [MetaSearchProfileByName]
}

PAEnvironment.registerBusinessObjectSearch("MetaBO", "Meta", MetaSearch, "Meta Search")

export {MetaSearch}
